import { useI18n } from 'next-localization';

import { NeuButton } from '@hcahealthcaredpx/neutron-react';

export const PrintButton = (): JSX.Element => {
  const { t } = useI18n();

  const printConfirmation = () => {
    // Can be used third paryty lib like in legacy - `printD` but this will add complexcity for something so small.
    // Added d-print-none class to Buttons so they wont be shown in the print + added @media print on modules.css
    window.print();
  };

  return (
    <NeuButton className="w-100 mb-4 d-none d-md-block d-print-none" onClick={printConfirmation}>
      {t('OAS.Booking.Confirmation.PrintConfirmation')}
    </NeuButton>
  );
};
